import Overlay from 'components/overlay';
import DropdownGuideSearch from 'components/dropdown_guide_search';

export default class MobileMenu {
  constructor(elem) {
    this.elem = document.querySelector(elem);
    this.root = document.querySelector('body');
    this.menuBtn = this.elem.querySelector('#mobile-menu-button');
    this.searchElem = this.elem.querySelector('#mobile-search');
    this.searchNav = this.elem.querySelector("#mobile-search-results");

    this.overlay = new Overlay;
    this.search = new DropdownGuideSearch(this.searchElem);

    this.menuOpen = false;

    this.addListeners();
  }

  addListeners() {
    //opening the menu
    this.menuBtn.addEventListener('click', this._toggleMenu.bind(this));
    //touching outside the nav
    this.overlay.element().addEventListener('click', this.closeMenu.bind(this));

    this.searchElem.addEventListener('open', this._openSearch.bind(this));
    this.searchElem.addEventListener('reset', this._resetSearch.bind(this));
    this.searchElem.addEventListener('focus', this._searchActive.bind(this));
  }

  openMenu() {
    this.root.classList.add('mobile-nav-active');
    this.overlay.open();

    this._markOpen();
  }

  closeMenu() {
    if (this.menuOpen) {
      this.root.classList.remove('mobile-nav-active');
      this.root.classList.remove('mobile-search-active');
      this._clearSearch();
      this.overlay.close();

      this._markClosed();
    }
  }

  _toggleMenu(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    if (this.menuOpen) {
      this.closeMenu();
    } else {
      this.openMenu();
    }
  }

  _searchActive() {
    this.root.classList.add('mobile-search-active');
    this.overlay.open();

    this._markOpen();
  }

  _markOpen() {
    this.menuOpen = true;
  }

  _markClosed() {
    this.menuOpen = false;
  }

  _openSearch(e) {
    this.searchNav.innerHTML = e.detail;
    this.root.classList.add('mobile-nav-active');
  }

  _resetSearch() {
    this.root.classList.remove('mobile-nav-active');
    this._clearSearch();
  }

  _clearSearch() {
    this.searchNav.innerHTML = "";
    this.search.reset();
  }
}
